/* src/app/shared/components/avatar/avatar.component.scss */
.user-avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.user-avatar-img {
  overflow: hidden;
  border-radius: 100%;
  margin: 0;
  position: relative;
}
.user-avatar-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.user-avatar-img:hover {
  opacity: 0.7;
}
.user-avatar--static {
  cursor: default;
}
.user-avatar-static .user-avatar-img:hover {
  opacity: 1;
}
.user-avatar-pictogram {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: uppercase;
}
.user-avatar-s .user-avatar-img {
  width: 24px;
  height: 24px;
}
.user-avatar-s .user-avatar-pictogram {
  font-size: 14px;
}
.user-avatar-m .user-avatar-img {
  width: 30px;
  height: 30px;
}
.user-avatar-m .user-avatar-pictogram {
  font-size: 20px;
}
.user-avatar-l .user-avatar-img {
  width: 50px;
  height: 50px;
}
.user-avatar-l .user-avatar-pictogram {
  font-size: 40px;
}
.user-avatar-xl .user-avatar-img {
  width: 150px;
  height: 150px;
}
.user-avatar-xl .user-avatar-pictogram {
  font-size: 140px;
}
/*# sourceMappingURL=avatar.component.css.map */
